module.exports = __webpack_public_path__ + "static/media/34DSS8.717976c7.jpg";